import { useTranslation } from 'react-i18next';
import { Alert } from '@/components/ui/misc';
import { formatDate } from '@/lib/format';
import { useFormat } from '@/lib/use-format';
import { closedThrough, useTimesheetLock } from '@/lib/use-timesheet-lock';

/**
 * Says that what is on screen is partly closed, and until when.
 *
 * `covers` is the dates the view shows, so the notice appears only where the closed period
 * actually reaches one of them: a week in the open future carries no banner about a month nobody
 * is looking at. Nothing is rendered for an administrator, who is not bound by it.
 */
export function ClosedPeriodNotice({ covers }: { covers: string[] }) {
  const { t } = useTranslation();
  const fmt = useFormat();
  const lock = useTimesheetLock();
  if (!lock.applies || !lock.lockDate || !covers.some(lock.isLocked)) return null;
  return (
    <Alert className="mb-3">
      {t('time.closedBanner', { date: formatDate(closedThrough(lock.lockDate), fmt) })}
    </Alert>
  );
}
